<div class="landing-page-container">
  <div class="header-container"> Søknad om tiltak uten ansvarsrett</div>
  <div class="content-container">
    <p>
      <strong>Du har ikke tilgang til å signere på vegne av {{application.developerName}}</strong>
    </p>
    <p>
      Dette kan skyldes én av to situasjoner, avhengig av hvem som er tiltakshaver i søknaden:
    </p>
    <p>
      <strong>1. Tiltakshaver er privatperson</strong><br />
      Navnet på tiltakshaver i søknaden må være identisk med navnet som er registrert på deg i Altinn. Hvis for eksempel et mellomnavn mangler eller navnet er skrevet på en annen måte, får du ikke tilgang til å signere søknaden.
    </p>
    <p>
      <em>Slik løser du det:</em><br />
      Kontakt den som har utarbeidet søknaden, og be om at navnet ditt kontrolleres og eventuelt korrigeres. Deretter må søknaden sendes til deg på nytt med en ny lenke for signering.
    </p>
    <p>
      <strong>2. Tiltakshaver er et foretak</strong><br />
      Skal du signere søknaden på vegne av et foretak, må du ha nødvendige rettigheter i Altinn for det aktuelle foretaket.
    </p>
    <p>
      <em>Slik løser du det:</em><br />
      For å signere må du ha tilgangspakken «Byggesøknad» under «Bygg, anlegg og eiendom» i Altinn. Tilgangen må gis av en person som har rettighet til å administrere Altinn-tilganger for foretaket, typisk daglig leder.
    </p>
    <p>
      Når tilgangen er tildelt, åpner du signeringslenken på nytt og logger inn igjen.
    </p>
    <ul>
      <li>
        <a href="https://www.dibk.no/verktoy-og-veivisere/slik-gir-du-andre-tilgang-i-altinn">Slik gir du andre tilgang i Altinn</a>
      </li>
      <li>
        <a href="https://info.altinn.no/hjelp/ny-tilgangsstyring/be-om-fullmakt">Slik ber du om fullmakt i Altinn</a>
      </li>
    </ul>

    <p>
      <strong>Er feil foretak eller feil person valgt som tiltakshaver?</strong>
    </p>
    <p>
      Kontakt {{application.contactPersonName}} hos {{application.contactCompanyName}}, slik at opplysningene kan rettes.<br /><br />
      Telefon: {{application.contactPhone}}<br />
      Mobil: {{application.contactMobile}}<br />
      E-post: {{application.contactEmail}}<br />
    </p>
  </div>
</div>
